<p>
    Chemistry Hotspots was commissioned by a postgraduate student who was
    exploring video games as an education tool. It quizzes the player on various
    molecular compounds.
</p>
